module.exports = __webpack_public_path__ + "static/media/e22.24e367dd.jpg";